<script>
import { onMount } from 'svelte';
import { ApplicationData } from '../../libraries/ApplicationData.js';
import { Contents } from '../ContentsPlatform.store.js';
import { turpial } from '../../libraries/turpial.js';
import { PaymentProviderStore } from './PaymentProviderStore.js';
import LoaderElement from './../Others/LoaderElement.svelte';


export let amount = 0;
export let currency = 'USD';
export let country = 'Colombia';
export let code_country = 'CO';
export let state = 'Cundinamarca';
export let state_code = 'CUN';
export let id_plan;
export let membership_type;
export let interval = "month";
export let on_success = () => {};
export let on_error = () => {};

export let email = null;
export let first_name = null;
export let last_name = null;
export let phone = null;
export let dial = null;
export let password = null;
export let password_repeat = null;
export let address = null;

export let city = null;
export let zip_code = null;
export let code_phone_verify = null;
export let is_online_context = null;
export let api_host = window.api_host || "";

$: if (is_online_context === true) {
    api_host = "https://app.3pod.io/api/v1/services/";
}

const IS_ONLINE_CHECK = is_online_context ?? window.IS_ONLINE ?? true;

if(IS_ONLINE_CHECK == false){
    if((email === null || email === "") && (first_name === null || first_name === "")){
        // dummy data:
        console.log("EMPTY MAIL PLACING DUMMY DATA")
        let random_string = turpial.random_string(6);
        email = "e_"+random_string+"@3pod.io";
        first_name = "Juan";
        last_name = "Perez";
        phone = "123456789";
        dial = "57";
        password = "jjaj123";
        password_repeat = "jjaj123";
        address = "123 Main St";
        state = "Cundinamarca";
        code_country = "CO";
        state_code = "CO";
        city = "Bogota";
        zip_code = "110221";
        code_phone_verify = "123456";
        membership_type = "suite";
        id_plan = "pl_A6fw1f3";
        interval = "month";
    }
}


let SMART_FIELDS_API_KEY = "2aac7a93-a828-4cd4-9a21-92fccf0e3d96";
let checkoutToken = null;
let cardField = null;
let loading = true;
let error = null;
let id_payment_attempt = null;
let processingPayment = false;

let document_type = "DNI";
let document_number = "";

onMount(async () => {
    try {
        await loadSDK();
        await initializePayment();
    } catch (err) {
        error = err.message;
        loading = false;
    }
});

async function loadSDK() {
    return new Promise((resolve, reject) => {
        if (window.dlocalGo) return resolve();
        const script = document.createElement('script');
        // Use sandbox URL if not online (assuming a way to detect, using a simple check or just sandbox for now)
        script.src = "https://checkout.dlocalgo.com/js/dlocalgo-smartfields-bundled.js";
        script.onload = resolve;
        script.onerror = () => reject(new Error("Failed to load DLocal Go SDK"));
        document.head.appendChild(script);
    });
}

async function initializePayment() {
    loading = true;
    try {
        const response = await fetch(`${api_host}public/dlocalgo_payment`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email,
                first_name,
                last_name,
                phone,
                dial,
                country,
                code_country,
                amount,
                currency,
                id_plan,
                membership_type,
                interval,
                password,
                password_repeat,
                address,
                state,
                state_code,
                city,
                zip_code,
                code_phone_verify,
                smart_fields: true,
                redirection_url: "user/",
                redirection_type: "internal"
            })
        });

        let result = await response.json();
        result = result?.response;
        if (result?.merchant_checkout_token) {
            checkoutToken = result.merchant_checkout_token;
            id_payment_attempt = result.payment_id;
            await initSmartFields();
        } else {
            throw new Error(result.message || "Failed to initialize payment");
        }
    } catch (err) {
        error = err.message;
    } finally {
        loading = false;
    }
}

async function initSmartFields() {
    await window.dlocalGo.initialize(SMART_FIELDS_API_KEY, checkoutToken);
    const fields = window.dlocalGo.fields();
    const style = {
        base: {
            fontSize: "16px",
            fontFamily: "'Montserrat', sans-serif",
            color: "#1D2C3B",
            "::placeholder": { color: "#AAB8C2" }
        }
    };
    cardField = fields.create("card", { style });
    cardField.mount("#dlocalgo-card-container");
}

export async function createToken() {
    if (processingPayment) return;
    processingPayment = true;
    error = null;

    try {
        const cardholderName = `${first_name} ${last_name}`.trim();
        const tokenResponse = await window.dlocalGo.createCardToken(cardField, {
            name: cardholderName
        });

        const cardToken = tokenResponse.token;
        PaymentProviderStore.setSmartFieldsData({
            cardToken,
            checkoutToken,
            id_payment_attempt,
            clientFirstName: first_name,
            clientLastName: last_name,
            clientEmail: email,
            clientDocumentType: document_type,
            clientDocument: document_number
        });
        return { token: { id: cardToken } };
    } catch (err) {
        error = err.message;
        throw err;
    } finally {
        processingPayment = false;
    }
}

async function handlePay() {
    try {
        const result = await createToken();
        const cardToken = result.token.id;

        const confirmResponse = await fetch(`${api_host}public/payments/dlocalgo/confirm`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                checkoutToken,
                cardToken,
                id_payment_attempt,
                clientFirstName: first_name,
                clientLastName: last_name,
                clientEmail: email,
                clientDocumentType: document_type,
                clientDocument: document_number
            })
        });

        const confirmResult = await confirmResponse.json();

        if (confirmResponse.ok && confirmResult.status === 'success') {
            on_success(confirmResult);
        } else if (confirmResult.status === 'pending_redirect') {
            window.location.href = confirmResult.redirect_url;
        } else {
            throw new Error(confirmResult.message || "Payment failed");
        }
    } catch (err) {
        error = err.message;
        on_error(err);
    }
}

export let show_submit_button = true;
</script>

<div class="dlocalgo-smart-fields mt-3">
    {#if loading}
        <div class="is-flex is-justify-content-center p-4">
            <LoaderElement message="" />
        </div>
    {:else if error}
        <div class="notification is-danger is-light p-2 font-size-12">
            <p>
                {error}
            </p>
            <button class="button is-small is-ghost" on:click={initializePayment}>Reintentar</button>
        </div>
    {:else}
        <div class="field">
            <label class="label font-size-14 fw600" for="cardholder-name">
                {$Contents.ctn_cardholder_name || "Nombre en la tarjeta"}
            </label>
            <div class="control is-flex is-gap-10">
                <input class="input" type="text" bind:value={first_name} placeholder="Nombre">
                <input class="input" type="text" bind:value={last_name} placeholder="Apellido">
            </div>
        </div>

        <div class="field">
            <label class="label font-size-14 fw600" for="document">
                {$Contents.ctn_document || "Documento de Identidad"}
            </label>
            <div class="control is-flex is-gap-10">
                <select class="select" bind:value={document_type} style="height: 40px; border-radius: 8px;">
                    <option value="DNI">DNI</option>
                    <option value="CI">CI</option>
                    <option value="RUT">RUT</option>
                    <option value="CPF">CPF</option>
                    <option value="OTHER">Otro</option>
                </select>
                <input class="input" type="text" bind:value={document_number} placeholder="Número de documento">
            </div>
        </div>

        <div class="field">
            <label class="label font-size-14 fw600" for="card-element">
                {$Contents.ctn_card_details || "Detalles de la tarjeta"}
            </label>
            <div id="dlocalgo-card-container" class="DlocalField"></div>
        </div>

        {#if show_submit_button}
            <button 
                type="button" 
                class="button primary-gradient-inverted has-text-white is-fullwidth mt-4" 
                on:click={handlePay}
                disabled={processingPayment || !document_number}
            >
                {#if processingPayment}
                    <span class="loader is-small mr-2"></span>
                    {$Contents.ctn_processing || "Procesando..."}
                {:else}
                    {$Contents.ctn_pay_now || "Pagar ahora"}
                {/if}
            </button>
        {/if}
    {/if}
</div>

<style>
    .DlocalField {
        background-color: white;
        height: 50px;
        padding: 12px;
        border-radius: 8px;
        border: 1px solid #dbdbdb;
        box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    
    .DlocalField:focus-within {
        border-color: var(--color-primary);
        box-shadow: 0 0 0 0.125em rgba(41, 111, 255, 0.25);
    }

    .loader {
        border: 2px solid #f3f3f3;
        border-top: 2px solid var(--color-primary);
        border-radius: 50%;
        width: 20px;
        height: 20px;
        animation: spin 1s linear infinite;
        display: inline-block;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>
